import { render, staticRenderFns } from "./SentenceSpeakingForm.vue?vue&type=template&id=0eda3e07&"
import script from "./SentenceSpeakingForm.vue?vue&type=script&lang=js&"
export * from "./SentenceSpeakingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports